import {useSelector} from 'react-redux';

import {IState} from '../../../store/reducers';
import {ApiStatus} from '../../../models';

export function useGetIntegrations(
  type: string,
) {
  const allIntegrations = useSelector((state: IState) => state.integration.integrations) || [];
  const integrations = allIntegrations.filter((integration: any) => integration.type === type);
  const loadingStatus = useSelector((state: IState) => state.integration.loadingStatus);
  const loaded = loadingStatus === ApiStatus.LOADED;
  const hasIntegrations = loaded && integrations?.length > 0;

  return {
    integrations,
    hasIntegrations,
  }
}
